import { useState, useCallback, useEffect } from 'react';

function Gallery() {
  const galleryMedia = [
    { id: 1, type: "video", src: "/images/gallery-2.mov" },
    { id: 2, type: "image", src: "/images/gallery-4.jpg", alt: "Turkey rearing at Motif Farms" },
    { id: 3, type: "image", src: "/images/gallery-7.jpg", alt: "Motif Farms facility" },
    { id: 4, type: "image", src: "/images/gallery-9.jpg", alt: "Turkey close-up" },
    { id: 5, type: "video", src: "/images/IMG_1309.MOV" },
    { id: 6, type: "video", src: "/images/IMG_5369.MOV" },
    { id: 7, type: "image", src: "/images/gallery-10.jpg", alt: "Farm surroundings" },
    { id: 8, type: "image", src: "/images/gallery-11.jpg", alt: "Motif Farms turkeys" },
  ];

  const [current, setCurrent] = useState(0);
  const total = galleryMedia.length;

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + total) % total);
  }, [total]);

  // Auto-advance for images only (not videos)
  useEffect(() => {
    const item = galleryMedia[current];
    if (item.type === 'video') return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [current, next]);

  const item = galleryMedia[current];

  return (
    <section className="py-24 px-6 bg-white dark:bg-background-dark" id="gallery">
      <div className="max-w-[1000px] mx-auto">

        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-black text-earth dark:text-white mb-2">
            Our Farm Gallery
          </h2>
          <p className="text-gray-500 font-medium">
            A glimpse into the daily life at Motif Farms.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative group">
          {/* Main Media Display */}
          <div className="relative overflow-hidden rounded-2xl shadow-2xl bg-black aspect-[16/10]">
            {item.type === 'video' ? (
              <video
                key={item.id}
                className="w-full h-full object-cover"
                src={item.src}
                muted
                loop
                autoPlay
                playsInline
              />
            ) : (
              <img
                key={item.id}
                loading="lazy"
                className="w-full h-full object-cover transition-opacity duration-500"
                src={item.src}
                alt={item.alt}
              />
            )}

            {/* Gradient overlays for button visibility */}
            <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>

            {/* Counter badge */}
            <div className="absolute top-4 right-4 bg-black/50 backdrop-blur-sm text-white text-sm font-bold px-3 py-1.5 rounded-full">
              {current + 1} / {total}
            </div>

            {/* Media type badge */}
            <div className="absolute top-4 left-4 bg-black/50 backdrop-blur-sm text-white text-sm font-medium px-3 py-1.5 rounded-full flex items-center gap-1.5">
              <span className="material-symbols-outlined text-sm">
                {item.type === 'video' ? 'videocam' : 'photo_camera'}
              </span>
              {item.type === 'video' ? 'Video' : 'Photo'}
            </div>

            {/* Prev Button */}
            <button
              onClick={prev}
              className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/90 dark:bg-gray-800/90 hover:bg-white dark:hover:bg-gray-700 w-11 h-11 rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 hover:scale-110"
            >
              <span className="material-symbols-outlined text-earth dark:text-white text-xl">chevron_left</span>
            </button>

            {/* Next Button */}
            <button
              onClick={next}
              className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/90 dark:bg-gray-800/90 hover:bg-white dark:hover:bg-gray-700 w-11 h-11 rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 hover:scale-110"
            >
              <span className="material-symbols-outlined text-earth dark:text-white text-xl">chevron_right</span>
            </button>
          </div>

          {/* Thumbnail Strip */}
          <div className="flex items-center justify-center gap-2 mt-5">
            {galleryMedia.map((media, index) => (
              <button
                key={media.id}
                onClick={() => setCurrent(index)}
                className={`relative overflow-hidden rounded-lg transition-all duration-300 ${index === current
                  ? 'ring-2 ring-primary ring-offset-2 w-16 h-12 opacity-100'
                  : 'w-12 h-10 opacity-50 hover:opacity-80'
                  }`}
              >
                {media.type === 'video' ? (
                  <div className="w-full h-full bg-gray-800 flex items-center justify-center">
                    <span className="material-symbols-outlined text-white text-xs">play_arrow</span>
                  </div>
                ) : (
                  <img
                    className="w-full h-full object-cover"
                    loading="lazy"
                    src={media.src}
                    alt={media.alt || ''}
                  />
                )}
              </button>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default Gallery;